// extracted by mini-css-extract-plugin
export default {"files":"Files_files__4EqmZ","fileContainer":"Files_fileContainer__aSTtp","filename":"Files_filename__3GF2d","fileDeleteIcon":"Files_fileDeleteIcon__fTiYI"};